<template>
  <div class="min-h-screen flex flex-col">
    <nav class="bg-base-100 shadow-lg">
      <Navbar />
    </nav>

    <main class="flex-grow">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    
    <!-- Create a dedicated element with a consistent height to reserve footer space -->
    <div class="footer-space" style="min-height: 470px;">
      <Footer />
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeMount } from 'vue'
import Navbar from './components/Navbar.vue'
import Footer from '@/components/Footer.vue'

// Apply CSS that prevents layout shifts before mount
onBeforeMount(() => {
  document.documentElement.classList.add('rendering-in-progress')
})

// Ensure fonts are loaded properly to prevent layout shifts
onMounted(() => {
  // Force font loading completion check
  document.fonts.ready.then(() => {
    document.documentElement.classList.add('fonts-loaded')
    document.documentElement.classList.remove('rendering-in-progress')
  })
  
  // Load full font weights asynchronously after initial render
  const fontLink = document.createElement('link')
  fontLink.rel = 'stylesheet'
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Quicksand:wght@300..700&display=swap&display=swap'
  document.head.appendChild(fontLink)
})
</script>

<style>
/* Remove @import to prevent render blocking - now handled in index.html and onMounted */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Prevent layout shifts while fonts are loading */
body {
  min-height: 100vh;
}

/* Prevent layout shifts during rendering */
.rendering-in-progress .footer-space {
  min-height: 470px;
  visibility: hidden;
}
</style> 